import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

type ProgramListContentOptions = {
  tabBarHeight?: number;
};

const stylesheet = StyleSheet.create(({ colors, spacing }, { insets }) => ({
  root: {
    flex: 1,
    overflow: "visible",
    // TV keeps the grouped panel; web/phone sit on the page with no column fill.
    ...CustomPlatform.select({
      tv: {
        backgroundColor: colors.backgroundDefault,
        borderTopLeftRadius: spacing(3),
        borderTopRightRadius: spacing(3),
      },
      default: {},
    }),
  },
  programList: {
    paddingTop: spacing(1),
    backgroundColor: "transparent",
  },
  /* Padding, not margin: rows scroll under the floating tab bar but the last one clears it. */
  programListContent: CustomPlatform.select({
    tv: (_: ProgramListContentOptions = {}) => ({
      paddingBottom: spacing(15),
    }),
    default: ({ tabBarHeight = 0 }: ProgramListContentOptions = {}) => ({
      paddingBottom: spacing(1) + tabBarHeight + insets.bottom,
    }),
  }),
}));

export default stylesheet;
